import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatNativeDateModule } from '@angular/material/core';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { SvgIconModule } from '../svg-icon/svg-icon.module';
import { DatePickerComponent } from './date-picker.component';
import { TranslateModule } from '@ngx-translate/core';
import { ClickOutsideDirective } from '../../directives/click-outside/click-outside.directive';

@NgModule({
  imports: [
    CommonModule,
    SvgIconModule,
    MatDatepickerModule,
    MatNativeDateModule,
    TranslateModule
  ],
  declarations: [
    DatePickerComponent,
    ClickOutsideDirective
  ],
  exports: [
    DatePickerComponent
  ]
})

export class DatePickerModule {}
